<template>
  <div
    v-if="stornierung && kostenlosStornierbar"
    v-html="
      stornierungKostenString ?
        $t('stornierung.kostenfrei_bis', {
          datum: stornierungKostenfreiBisString,
          betrag: stornierungKostenString,
        })
      :
        $t('stornierung.kostenfrei_bis_ohne', {
          datum: stornierungKostenfreiBisString
        })
    "
    class="alert alert-success text-left"
  ></div>
  <div
    v-else-if="stornierung && !kostenlosStornierbar"
    v-html="
      stornierungKostenString ?
        $t('stornierung.nicht_kostenfrei', { betrag: stornierungKostenString })
      :
        $t('stornierung.nicht_kostenfrei_ohne')
    "
    class="alert alert-warning text-left"
  ></div>
</template>

<script>
  import { DateTime } from "luxon";

  export default {
    name: "StornierungAlert",
    props: {
      stornierung: {
        type: Object,
      },
    },
    computed: {
      stornierungKostenfreiBis() {
        return this.stornierung
          ? DateTime.fromISO(this.stornierung.kostenfrei_bis).toJSDate()
          : null;
      },
      stornierungKostenfreiBisString() {
        return this.stornierungKostenfreiBis
          ? `${this.$options.filters.dateLong(this.stornierungKostenfreiBis)} ${this.$options.filters.clock(this.stornierungKostenfreiBis)} ${this.$t("uhr")}`
          : null;
      },
      stornierungKosten() {
        return this.stornierung?.gebuehr || 0;
      },
      stornierungKostenString() {
        return this.stornierungKosten
          ? this.$options.filters.preis(this.stornierungKosten)
          : null;
      },
      kostenlosStornierbar() {
        return (
          this.stornierungKostenfreiBis &&
          this.stornierungKostenfreiBis.getTime() >= new Date().getTime()
        );
      },
    },
  };
</script>

<style>
</style>
